module.exports = __webpack_public_path__ + "img/brut.1e8fc31a.jpg";